import React from "react";

function ActivationsCountToday({activationsPerSchoolToday, cardActivationsToday, wbActivationsToday}) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const todayFormatted = new Date().toLocaleDateString('en-US', options);

    return (
        <div className="col-lg-12">
            <div className="card custom-card" style={{paddingBottom:"10px"}}>
            <div className="card-body map-card">
                <div className="item-title">
                <h5 style={{marginBottom:10}}>Activations Today ({todayFormatted})</h5>
                </div>
                <table className="table mb-0 color-span">
                <thead>
                <tr>
                <th className="w-50">School</th>
                <th></th>

                <th className="py-2 px-0" scope="col">Card</th>
                <th className="py-2 px-0"scope="col"> Wristband</th>
                </tr>
                </thead>
                <tbody>
                {activationsPerSchoolToday === "404" ? (
    <tr>
      <td colSpan="4" style={{ textAlign: "center" }} className="py-2 px-0">
        No activations today
      </td>
    </tr>
  ) : (
    Object.keys(activationsPerSchoolToday).map((schoolId, key) => {
      const school = activationsPerSchoolToday[schoolId];
      return (
        <tr key={key}>
          <td className="py-2 px-0">
            <span className="w-50">{school.school_name}</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
              {/* Safe access to activations[4] with fallback to 0 */}
              {school.activations?.[4] || 0}
            </span>
          </td>
          <td className="py-2 px-0">
            <span className="">
              {/* Safe access to activations[12] with fallback to 0 */}
              {school.activations?.[12] || 0}
            </span>
          </td>
        </tr>
      );
    })
  )}
  <tr>
                   
                    <td className="py-2 px-0">{" "}
                        <span className="w-50">
                        Total{" "}
                        </span>{" "}
                    </td>
                    <td>:</td>
                    <td className="py-2 px-0">{" "}
                        <span className="">
                        {cardActivationsToday?cardActivationsToday.total_c:"..."}
                        </span>{" "}
                    </td>
                    <td className="py-2 px-0">{" "}
                        <span className="">
                        {wbActivationsToday?wbActivationsToday.total_c:"..."}
                        </span>{" "}
                    </td>
                    </tr>
                   
                </tbody>
                </table>
            </div>
            </div>
        </div>
        
    );
}

export default ActivationsCountToday;
